import { CountUp } from 'countup.js';

export const statsCounter = () => {
  const numbers = document.querySelectorAll('.number');

  if (!numbers.length) return;

  numbers.forEach((number) => {
    // get the number from the string
    const numberValue = number.textContent.replace(/[^0-9.]/g, '');

    // get the index of the first number
    const firstIntIndex = number.textContent.search(/\d/);

    let hasPrefix, hasSuffix;

    // if firstIntIndex > 0, then there is a prefix
    if (firstIntIndex > 0) {
      hasPrefix = number.textContent.substring(0, firstIntIndex);
      hasSuffix = number.textContent.replace(/[0-9]/g, '').slice(firstIntIndex);
    } else {
      hasPrefix = false;
      hasSuffix = number.textContent.replace(/[0-9]/g, '');
    }

    const prefix = hasPrefix ? hasPrefix : '';
    let suffix = hasSuffix ? hasSuffix : '';

    const hasDecimals = numberValue.indexOf('.') === -1 ? 0 : 1;

    if (suffix === '.') {
      suffix = '';
    }

    const options = {
      startVal: 0,
      useEasing: false,
      useGrouping: true,
      decimalPlaces: hasDecimals,
      duration: 3,
      scrollSpyDelay: 0,
      prefix: prefix,
      suffix: suffix,
      enableScrollSpy: true,
      scrollSpyOnce: true,
    };

    if (numberValue && parseFloat(numberValue) === 1) {
      new CountUp(number, parseFloat(numberValue), { ...options, duration: 1 });
    }

    if (numberValue && parseFloat(numberValue) > 1) {
      new CountUp(number, parseFloat(numberValue), options);
    }
  });
};
